import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ShipTheory_ModuleContextService } from './ShipTheory.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ShipTheory_shiptheory_library_home_ComponentContextService {
  private readonly moduleContext: ShipTheory_ModuleContextService;

  constructor(moduleContext: ShipTheory_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'shiptheory_library_home',
      type: ComponentType.form
    }
  }
}